<template>
  <v-container fluid>
    <v-row class="text-white pt-4">
      <!-- Left Column: Company Information -->
      <v-col cols="12" md="3" class="mb-8">
        <h3 class="font-weight-bold">Web Innovation</h3>
        <p class="mt-4">
          We value collaboration and transparency. We work closely with you at
          every step, ensuring your goals are met with precision and creativity.
          Let’s build something amazing together.
        </p>
      </v-col>

      <!-- Middle Left Column: Our Services -->
      <v-col cols="12" md="3" class="mb-8">
        <h3 class="font-weight-bold">Our Services</h3>
        <span class="blue-line"></span>
        <ul class="list-unstyled mt-4">
          <li>UI/UX Design</li>
          <li>Web Development</li>
          <li>E-Commerce Development</li>
          <li>SEO and Digital Marketing</li>
          <li>Migration and Redesign Services</li>
          <li>Content Management System</li>
          <li>Website Maintenance and Support</li>
          <li>Graphic Designing</li>
        </ul>
      </v-col>

      <!-- Middle Right Column: Useful Links -->
      <v-col cols="12" md="3" class="mb-8">
        <h3 class="font-weight-bold">Useful Links</h3>
        <span class="blue-line"></span>
        <ul class="list-unstyled mt-4">
          <li>
            <router-link to="/" active-class="active-link">Home</router-link>
          </li>
          <li>
            <router-link to="/about" active-class="active-link"
              >About Us</router-link
            >
          </li>
          <li>
            <router-link to="/services" active-class="active-link"
              >Our Services</router-link
            >
          </li>
          <li>
            <router-link to="/contact" active-class="active-link"
              >Contact Us</router-link
            >
          </li>
        </ul>
      </v-col>

      <!-- Right Column: Subscribe and Social Media -->
      <v-col cols="12" md="3" class="mb-8">
        <h3 class="font-weight-bold">Subscribe Us</h3>
        <span class="blue-line"></span>
        <v-text-field
          placeholder="Enter your email..."
          variant="outlined"
          density="compact"
          class="text-white mt-4"
          v-model="subscriptionEmail"
          :error-messages="errorMessages"
        >
          <template v-slot:append-inner>
            <v-icon
              @click="validateAndSendEmail"
              class="search-close-icon cursor-pointer"
              >mdi-send</v-icon
            >
          </template>
        </v-text-field>
        <v-snackbar v-model="subscribedToast">
          Subscribed successfully
        </v-snackbar>
        <h3 class="font-weight-bold mt-4 mb-3">Follow us on Social</h3>
        <v-icon class="mr-3 f-icon">mdi-whatsapp</v-icon>
        <v-icon class="mr-3 f-icon">mdi-facebook</v-icon>
        <v-icon class="mr-3 f-icon">mdi-twitter</v-icon>
        <v-icon class="f-icon">mdi-linkedin</v-icon>
      </v-col>
    </v-row>
    <v-row justify="center" class="text-center mt-4 pb-3">
      <span class="text-white"
        >Crafted by
        <a
          target="_blank"
          class="lj-link"
          href="https://lebinjoseui.netlify.app"
          >Lebin Jose</a
        ></span
      >
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const subscriptionEmail = ref("");
const errorMessages = ref([]);
const subscribedToast = ref(false);

// Email validation function
const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

// Email validation and sending function
const validateAndSendEmail = () => {
  errorMessages.value = []; // Reset error messages

  // Validate if email is entered and is correct
  if (!subscriptionEmail.value) {
    errorMessages.value.push("Email is required.");
  } else if (!validateEmail(subscriptionEmail.value)) {
    errorMessages.value.push("Please enter a valid email address.");
  }

  // If no errors, proceed with sending email logic
  if (errorMessages.value.length === 0) {
    sendEmail();
  }
};

// Placeholder for email sending logic
const sendEmail = () => {
  console.log("Email sent to:", subscriptionEmail.value);
  router.push({ name: "home" });
  subscribedToast.value = true;
};

// Watch subscriptionEmail to reset errors when email field is cleared
watch(subscriptionEmail, (newValue) => {
  if (!newValue) {
    errorMessages.value = [];
  }
});
</script>
